import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { updateSearch } from 'bernie-core';
import { ErrorBoundary } from 'bernie-view';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { parse } from 'query-string';
import { SEARCH_ID } from 'src/common/constants/analytics';
import { useLocalization } from '@shared-ui/localization-context';
import { InfositeQueryAdapter } from 'stores/adapters/infosite-query-adapter';
import { SearchQueryAdapter } from 'stores/adapters/search-query-adapter';
import { singleUseQueryParams } from 'stores/models';
import { multiItemCompleteSearchCriteria } from 'components/multi-item/utils';
// @ts-ignore
import { SearchWizardComposer } from './search-wizard-composer';
export const SingleOfferSearchForm = props => React.createElement(WrappedSingleOffer, Object.assign({}, props));
SingleOfferSearchForm.displayName = 'SingleOfferSearchForm';
export const WrappedSingleOffer = inject('currentHotel', 'context', 'analyticsSearch')(observer(({
  currentHotel,
  context,
  analyticsSearch
}) => {
  const l10n = useLocalization();
  const history = useHistory();
  const location = useLocation();
  const navigateTo = submitUrl => {
    history.push(submitUrl);
  };
  const onUpdateResults = searchCriteria => {
    handleUpdateResults({
      context,
      analyticsSearch,
      criteria: searchCriteria.toJSON(multiItemCompleteSearchCriteria),
      history,
      location,
      l10n
    });
  };
  React.useEffect(() => {
    const searchCriteria = currentHotel || undefined;
    const {
      startDate,
      endDate,
      adults,
      children
    } = SearchQueryAdapter.parseOut(searchCriteria);
    // 0 - children from search is undefined
    const childrenFormatted = typeof children === 'undefined' ? '' : children;
    currentHotel === null || currentHotel === void 0 ? void 0 : currentHotel.setOfferData({
      startDate,
      endDate,
      adults,
      children: childrenFormatted
    });
  }, [currentHotel]);
  const searchWizardComposerProps = {
    navigateTo,
    onUpdateResults
  };
  return React.createElement(ErrorBoundary, {
    label: "hotel.information.searchform.singleoffer"
  }, React.createElement(EGDSSpacing, {
    padding: {
      inline: 'three'
    }
  }, React.createElement("div", null, React.createElement(SearchWizardComposer, Object.assign({}, searchWizardComposerProps)))));
}));
const isInvalidQueryParamValue = queryParamValue => {
  var _a;
  return queryParamValue === undefined || queryParamValue === null || (Array.isArray(queryParamValue) || typeof queryParamValue === 'string') && !(queryParamValue === null || queryParamValue === void 0 ? void 0 : queryParamValue.length) || typeof queryParamValue === 'object' && !((_a = Object.keys(queryParamValue !== null && queryParamValue !== void 0 ? queryParamValue : {})) === null || _a === void 0 ? void 0 : _a.length);
};
export const handleUpdateResults = ({
  context,
  analyticsSearch,
  criteria,
  history,
  location,
  l10n
}) => {
  analyticsSearch === null || analyticsSearch === void 0 ? void 0 : analyticsSearch.newSearchId();
  const params = Object.assign(Object.assign({}, criteria), {
    [SEARCH_ID]: analyticsSearch === null || analyticsSearch === void 0 ? void 0 : analyticsSearch.searchId,
    localDateFormat: context === null || context === void 0 ? void 0 : context.localDateFormat
  });
  const queryObj = parse(location.search);
  const newParams = InfositeQueryAdapter.parseOut(params, l10n);
  const paramsFilter = key => !key.startsWith('pwaDialog') && !key.startsWith('rm') && !singleUseQueryParams.includes(key) && !isInvalidQueryParamValue(queryObj[key]);
  const allKeys = Object.keys(newParams);
  allKeys.forEach(key => {
    if (isInvalidQueryParamValue(newParams[key])) {
      // disabling the eslint  error warning 'Do not delete dynamically computed property keys' as the following logic is to remove null/empty keys
      // eslint-disable-next-line
      delete newParams[key];
    }
  });
  const hasOpenDialog = Boolean(parse(location.search).pwaDialog);
  if (hasOpenDialog) {
    // HACK: we used to listen for window popstate event before making the call to updateSearch to update url params
    // but bernie no longer calls history.goBack() when a dialog closes so the event is never fired. Until we can come
    // up with another bernie fix for the race condition that occurs between this updateSearch call and the same call in
    // bernie dialog-context - we'll have to use the setTimeout here
    setTimeout(() => updateSearch({
      history,
      location,
      newParams,
      replace: true,
      paramsFilter
    }), 50);
  } else {
    updateSearch({
      history,
      location,
      newParams,
      replace: true,
      paramsFilter
    });
  }
};